// If current time is before 05:00 London time, disable date from yesterday
export const checkDate = (now: Date, nightShiftEndHour: number) => {
    const londonHour = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/London' })).getHours()

    const previousDay = new Date(now)
    previousDay.setDate(now.getDate() - 1)

    return londonHour < nightShiftEndHour ? previousDay : undefined
}
